import round from 'lodash/round';

export const formattedValue = (value: number, unit?: '$' | 'USD' | 'GB') => {
	const num = round(value, 2);

	if (!unit) {
		return num;
	}

	if (unit === 'GB') {
		return `${num} GB`;
	}

	return `${['$', 'USD'].includes(unit) ? num.toFixed(2) : num}${unit === 'USD' ? ' ' : ''}${unit}`;
};
